import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadePaginateResponse, UnidadesPaginateQuery } from "./typings/unidade";

function useAllUnidades(tenantId?: string, params?: UnidadesPaginateQuery) {
  // KEY -> 1 e 99999 é a página e o limit da consulta.
  return useQuery(
    [`/v1/unidades`, tenantId, params],
    async () => {
      const res = await axios.get<PaginateResult<UnidadePaginateResponse>>(
        `/v1/unidades`,
        {
          params: {
            page: 1,
            limit: 99999,
            tenantId,
            ...(params ?? {}),
          },
        }
      );

      return res.data;
    }
  );
}

export default useAllUnidades;
